/* eslint-disable indent */
import { USER_ACCOUNT_URL, USER_URL } from '../../constants';
import {
  BadRequest,
  GeneralError,
  ServerError,
  UserNotFound,
} from '../../utils/errors';
import { api } from './API';

export const getUserAPI = async () => {
  try {
    const response = await api().get(USER_URL);
    handleAPIResponse(response);
    return response.data.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

export const getAccountContactsAPI = async () => {
  try {
    const response = await api().get(`installer/account/contacts`);
    handleAPIResponse(response);
    return response.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

export const createAccountContactAPI = async (contactData) => {
  try {
    const response = await api().post(
      `installer/account/contacts`,
      contactData
    );
    handleAPIResponse(response);
    return response.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

export const updateAccountContactAPI = async (contactId, contactData) => {
  try {
    const response = await api().put(
      `installer/account/contacts/${contactId}`,
      contactData
    );
    handleAPIResponse(response);
    return response.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

export const deactivateAccountContactAPI = async (contactId) => {
  try {
    const response = await api().post(
      `installer/account/contacts/${contactId}/deactivate`
    );
    handleAPIResponse(response);
    return response.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

export const reactivateAccountContactAPI = async (contactId) => {
  try {
    const response = await api().post(
      `installer/account/contacts/${contactId}/reactivate`
    );
    handleAPIResponse(response);
    return response.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

export const resendInvitationToAccountContactAPI = async (contactId) => {
  try {
    const response = await api().post(
      `installer/account/contacts/${contactId}/resend-invitation`
    );
    handleAPIResponse(response);
    return response.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

export const resendVerificationToAccountContactAPI = async (contactId) => {
  try {
    const response = await api().post(
      `installer/account/contacts/${contactId}/resend-verification`
    );
    handleAPIResponse(response);
    return response.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

export const listAccountContactsActivityAPI = async () => {
  try {
    const response = await api().get(`installer/account/contacts/activity`);
    handleAPIResponse(response);
    return response.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

export const updateUserAPI = async (userData) => {
  try {
    const response = await api().put(USER_URL, userData);
    handleAPIResponse(response);
    return response.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

export const updateAccountAPI = async (accountData) => {
  try {
    const response = await api().put(USER_ACCOUNT_URL, accountData);
    handleAPIResponse(response);
    return response.data;
  } catch (error) {
    console.error(error);
    handleAPIResponse(error.response);
  }
};

const handleAPIResponse = (response) => {
  const { status, data } = response;
  // Most of default django errors set 'detail' field in response
  const detail = data?.detail;
  // If detail field is set, put it's contents as the message for the error
  const errorData = detail ? { message: detail } : { data };
  switch (status) {
    case 200:
    case 201:
      break;

    case 400:
      throw new BadRequest(errorData);

    case 401:
      throw new UserNotFound(errorData);

    case 503:
      throw new ServerError(errorData);

    default:
      throw new GeneralError(errorData);
  }
};
